(() => {
  'use strict';

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const getMain = () =>
    document.querySelector('main#main, #main, main') || document.body;

  const replaceText = (root, from, to) => {
    if (!root || !from) return 0;

    const pattern = new RegExp(escapeRegExp(from), 'gi');
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest('script, style, noscript, textarea')) {
          return NodeFilter.FILTER_REJECT;
        }
        pattern.lastIndex = 0;
        return pattern.test(node.nodeValue || '')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });

    const matches = [];
    while (walker.nextNode()) matches.push(walker.currentNode);

    matches.forEach((node) => {
      pattern.lastIndex = 0;
      node.nodeValue = node.nodeValue.replace(pattern, to);
    });

    return matches.length;
  };

  const matchesLabel = (text, labels) => {
    const normalized = normalize(text).toLowerCase();
    return labels.some((label) => {
      const target = normalize(label).toLowerCase();
      return normalized === target || normalized.startsWith(`${target} `);
    });
  };

  const setLinks = (root, labels, href) => {
    if (!root) return 0;
    let changed = 0;

    root.querySelectorAll('a').forEach((anchor) => {
      if (matchesLabel(anchor.textContent, labels)) {
        anchor.setAttribute('href', href);
        changed += 1;
      }
    });

    return changed;
  };

  const findTextElement = (
    root,
    needle,
    selector = 'h1, h2, h3, h4, h5, p, a, button, span'
  ) => {
    const target = normalize(needle).toLowerCase();
    return Array.from(root.querySelectorAll(selector)).find((element) =>
      normalize(element.textContent).toLowerCase().includes(target)
    );
  };

  const findCard = (root, title) => {
    const titleElement = findTextElement(
      root,
      title,
      'h1, h2, h3, h4, h5, a, strong'
    );
    if (!titleElement) return null;

    const titleKey = normalize(title).toLowerCase();
    let node = titleElement;
    let fallback = null;

    while (node && node !== root && node !== document.body) {
      const text = normalize(node.textContent).toLowerCase();
      const hasImage = Boolean(node.querySelector?.('img'));
      const hasLink = Boolean(node.querySelector?.('a'));

      if (
        hasImage &&
        hasLink &&
        text.includes(titleKey) &&
        text.length < 6000
      ) {
        fallback = node;
        if (
          node.matches(
            'article, li, product-page, [class*="card"], [class*="product"], [class*="bundle"]'
          )
        ) {
          return node;
        }
      }

      node = node.parentElement;
    }

    return fallback;
  };

  const buildSummary = (content) => {
    const fragment = document.createDocumentFragment();

    if (typeof content === 'string') {
      const paragraph = document.createElement('p');
      paragraph.textContent = content;
      fragment.append(paragraph);
      return fragment;
    }

    if (content?.summary) {
      const paragraph = document.createElement('p');
      paragraph.textContent = content.summary;
      fragment.append(paragraph);
    }

    if (content?.heading) {
      const heading = document.createElement('h3');
      heading.textContent = content.heading;
      fragment.append(heading);
    }

    if (Array.isArray(content?.bullets) && content.bullets.length) {
      const list = document.createElement('ul');

      content.bullets.forEach((item) => {
        const listItem = document.createElement('li');
        listItem.textContent = item;
        list.append(listItem);
      });

      fragment.append(list);
    }

    return fragment;
  };

  const condenseCard = (card, content) => {
    if (!card) return;

    const description =
      card.querySelector('[data-description-content]') ||
      card.querySelector(
        'product-description-reveal .product-description-reveal__content'
      );

    if (description) {
      description.replaceChildren(buildSummary(content));
      description.dataset.p2HomeSummary = 'true';

      const reveal = description.closest('product-description-reveal');
      if (reveal) {
        reveal.classList.add('is-ready', 'is-expanded');
        reveal.classList.remove('has-overflow');
        reveal.style.setProperty('--description-preview-height', 'none');
        reveal.querySelector('[data-description-toggle]')?.remove();
      }

      return;
    }

    const paragraphs = Array.from(card.querySelectorAll('p')).filter((element) => {
      const text = normalize(element.textContent);
      return text.length > 24 && !element.closest('button, a');
    });

    const target = paragraphs.sort(
      (a, b) => normalize(b.textContent).length - normalize(a.textContent).length
    )[0];

    if (target) {
      target.replaceChildren(buildSummary(content));
      paragraphs.forEach((paragraph) => {
        if (paragraph !== target) paragraph.hidden = true;
      });
    }

    card.querySelectorAll('ul, ol').forEach((list) => {
      if (!target?.contains(list)) list.hidden = true;
    });
  };

  const setCardCopy = (root, title, content) => {
    const card = findCard(root, title);
    condenseCard(card, content);
    return card;
  };

  window.CoastalSoulP2 = {
    normalize,
    getMain,
    replaceText,
    setLinks,
    findTextElement,
    findCard,
    condenseCard,
    setCardCopy
  };
})();
